import { AfterViewInit, Component, NgZone, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ZoomMtg } from '@zoom/meetingsdk';
import { combineLatest, filter, lastValueFrom, map, Subject } from 'rxjs';
import { EventService } from '../services/event.service';
import { ZoomStatusService } from './services/zoom-status.service';

ZoomMtg.preLoadWasm();
ZoomMtg.prepareWebSDK();

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  pingIntervalId: any;
  authEndpoint = 'http://localhost:3000/getSignature'
  // sdkKey = 'RqXMmTy8RDOqsAqK0Y6U_A'
  // meetingNumber = '81260973801'
  // passWord = ''
  role = 0
  zakToken = ''
  userName = ''
  userEmail = ''
  registrantToken = 'iFRKETHSv7vkcnShMIRy8Aqh0LzqRFVh9ynCYPmhrBY.DQkAAAATssjVBhZWb3ZHeWo0UlNoS3FyM0N5UUZYTE53AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA'
  leaveUrl = 'https://sicuentame.com'
  evento
  private viewInit$ = new Subject<void>();
  loading = true
  
  constructor(private ngZone: NgZone, private route: ActivatedRoute, private eventService: EventService, private zoomStatus: ZoomStatusService){

  }

  ngAfterViewInit(): void {
    // if (this.evento !== undefined) {
    //   this.cargarVista(this.evento);
    // }

    // this.viewInit$.next();

    // El spinner se quita cuando Zoom responde o cuando LiveeventComponent marca error (ver ZOOM_TIMEOUT_MS)
    this.zoomStatus.status$.subscribe(status => {
      this.loading = status === 'loading'
    })
  }

  async cargarVista(evento){
    console.log(evento)
    await this.decodeToken()
    let responseEvent =  await lastValueFrom(this.eventService.getWebinarData(evento))
    let responseAccess =  await lastValueFrom(this.eventService.getWebinarAccess(responseEvent.data.liveEventAttendeeId))
    const meetingSDKElement = document.getElementById('meetingSDKElement');
    if (!meetingSDKElement) {
      console.error('meetingSDKElement no encontrado');
      return;
    }
    console.log('YA CARGO EL EVENTO', evento)

    document.getElementById('zmmtg-root')!.style.display = 'block !important'

    this.ngZone.runOutsideAngular(() => {
      ZoomMtg.i18n.load('es-ES');
      ZoomMtg.i18n.reload('es-ES');
      ZoomMtg.init({
        leaveUrl: this.leaveUrl,
        patchJsMedia: true,
        leaveOnPageUnload: true,
        success: (success: any) => {
          console.log(success)
          ZoomMtg.join({
            signature: responseEvent.data.signature,
            meetingNumber: responseEvent.data.nextSession.zoomMeetingId,
            passWord: '',
            userName: this.userName,
            userEmail: this.userEmail,
            tk: responseAccess.data.liveEventAttendees[0].zoomRegistrantToken,
            // zak: this.zakToken,
            success: (success: any) => {
              ZoomMtg.inMeetingServiceListener('onMeetingStatus', (data: any) => {
                const estado = data.meetingStatus;
                if (estado === 3 || estado === 4) {
                  console.log('La reunión ha terminado o se está cerrando');
                  this.sendFinishPing();
                  this.stopCurrentPing();
                  // Redirige o actualiza tu UI aquí
                }
              });
              this.sendStartedPing()
              this.startCurrentPing()
              console.log(success)
            },
            error: (error: any) => {
              console.log(error)
            }
          })
        },
        error: (error: any) => {
          console.log(error)
        }
      })
    })
  }

  ngOnInit(): void {
    // this.route.queryParams.subscribe(params => {
    //   this.evento = params['evento'];
    //   console.log(this.evento);
    // });

    // const evento$ = this.route.queryParamMap.pipe(
    //   map(params => params.get('evento')),
    //   filter(evento => !!evento)
    // );

    // combineLatest([evento$, this.viewInit$])
    //   .subscribe(([evento]) => {
    //     this.cargarVista(evento as string);
    // });


  }

  async decodeToken() {
    const cookie = document.cookie.match(new RegExp('(^| )' + 'cuentame_token' + '=([^;]+)'));
    // const token = localStorage.getItem('id_token');
    // console.log(token)
    const token = cookie ? cookie[2] : null;
    console.log(token)

    const payload = token!.split('.')[1]; // segunda parte del JWT
    const decoded = atob(payload.replace(/-/g, '+').replace(/_/g, '/')); // decodifica Base64
    const data = JSON.parse(decoded)
    this.userName = data.firstName;
    this.userEmail = data.email;
    // return JSON.parse(decoded); // convierte a objeto
  }

  sendStartedPing(){
    console.log('SE INICIO')
  }

  sendFinishPing(){
    console.log('SE TERMINO')
  }

  startCurrentPing(){
    this.pingIntervalId = setInterval(() => {
      console.log('activo')
    }, 5000);
  }

  stopCurrentPing(){
    if (this.pingIntervalId) {
      console.log('DESACTIVADO')
      clearInterval(this.pingIntervalId);
      this.pingIntervalId = null;
    }
  }

  ngOnDestroy(): void {
    const zoomRoot = document.getElementById('zoom-root');
    if (zoomRoot) {
      zoomRoot.innerHTML = '';
      zoomRoot.removeAttribute('style'); // elimina estilos inline
    }

    // También puedes resetear el body si Zoom lo modificó
    document.body.style.backgroundColor = '';
  }
}
